import { ComplaintsEntity } from "../complaints.entity";
import { ComplaintsDTO } from "./complaints.dto";

export class ComplaintsAdapter{
    
    convertDtoToEntity(dtoObj: ComplaintsDTO, isUpdate: boolean = false): ComplaintsEntity{
        try{
            const entityObj = new ComplaintsEntity();
            entityObj.complaintId = dtoObj.complaintId;
            entityObj.complaint = dtoObj.complaint;
            entityObj.departmentId = dtoObj.departmentId;
            entityObj.departmentName = dtoObj.departmentName;
            entityObj.complaintRaisedDate = dtoObj.complaintRaisedDate;
            entityObj.status = dtoObj.status;
            if(isUpdate){
                entityObj.updatedUser = dtoObj.updatedUser;
            }else {
                entityObj.isActive = true;
                entityObj.createdUser = dtoObj.createdUser;
            }
            return entityObj;
        }catch(error){
            throw error;
        }
    }

    convertEntityToDto(entityObj: ComplaintsEntity): ComplaintsDTO{
        
            const dtoObj = new ComplaintsDTO();
            dtoObj.complaintId = entityObj.complaintId;
            dtoObj.complaint = entityObj.complaint;
            dtoObj.departmentId = entityObj.departmentId;
            dtoObj.departmentName = entityObj.departmentName;
            dtoObj.complaintRaisedDate = entityObj.complaintRaisedDate;
            dtoObj.status = entityObj.status;
            dtoObj.isActive = entityObj.isActive;
            dtoObj.createdAt = entityObj.createdAt;
            dtoObj.createdUser = entityObj.createdUser;
            dtoObj.updatedAt = entityObj.updatedAt;
            dtoObj.updatedUser = entityObj.updatedUser;
            dtoObj.versionFlag = entityObj.versionFlag;
            return dtoObj;
    }
}